var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: true,
        "hide-footer": "",
        scrollable: false,
        size: "lg",
        title: "Define a Background for your Preview",
      },
      on: {
        closed: function ($event) {
          return _setup.emit("cancel")
        },
      },
    },
    [
      _c("div", { staticClass: "bg-mode-container" }, [
        _c(
          "div",
          { staticClass: "bg-mode" },
          [
            _c("img", {
              attrs: {
                src: _setup.PreviewImageExample,
                alt: "image-example",
                height: "350",
                width: "350",
              },
            }),
            _vm._v(" "),
            _c("h6", { staticClass: "title" }, [
              _vm._v("Upload Background Image"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                The preview size will adapt to your image's aspect ratio. Upload images up to 1200px for best\n                performance on your store. Large images will be scaled down automatically.\n            "
              ),
            ]),
            _vm._v(" "),
            _c(_setup.CFileInput, {
              staticClass: "mt-auto",
              attrs: {
                "display-preview": false,
                accept: ".png,.jpg,.jpeg,.webp",
                "button-text": "Upload Image",
              },
              on: { input: _setup.onImageUploaded },
              scopedSlots: _vm._u([
                {
                  key: "uploadTrigger",
                  fn: function ({ onFileUpload }) {
                    return [
                      _c(_setup.CButton, {
                        staticClass: "flex-fill",
                        attrs: { variant: "primary", text: "Upload Image" },
                        on: { click: onFileUpload },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _setup.model.files,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "files", $$v)
                },
                expression: "model.files",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bg-mode" },
          [
            _c("img", {
              staticClass: "color-example",
              style: { "--preview-bg-color": _setup.rgbaColor },
              attrs: {
                src: _setup.PreviewColorExample,
                alt: "color-example",
                height: "350",
                width: "350",
              },
            }),
            _vm._v(" "),
            _c("h6", { staticClass: "title" }, [
              _vm._v("Select Background Color"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Choose any color and set your preview size by entering width and height (in px)."
              ),
            ]),
            _vm._v(" "),
            _c(_setup.ColorSelector, {
              ref: "pickerRef",
              staticClass: "color-selector",
              attrs: {
                open: _setup.clickOutsideActive,
                color: _setup.model.color,
              },
              on: {
                cancel: _setup.toggleColorSelection,
                "color-selected": _setup.onBgColorSelected,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "color-preview rounded",
                style: { "--preview-bg-color": _setup.rgbaColor },
                on: { click: _setup.toggleColorSelection },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "edit-icon",
                  attrs: { icon: ["fas", "pen"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(_setup.ValidationObserver, {
              attrs: { tag: "div" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ invalid }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(_setup.ValidationProvider, {
                            attrs: {
                              slim: "",
                              rules: _setup.validation.rules,
                              "custom-messages": _setup.validation.messages,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ failed, errors }) {
                                    return [
                                      _c(_setup.CInput, {
                                        staticClass: "flex-fill mr-2",
                                        attrs: {
                                          label: "Width (px)",
                                          type: "decimal",
                                          min: 1,
                                          step: 1,
                                          error: failed,
                                          "error-msg": errors[0],
                                        },
                                        model: {
                                          value: _setup.model.width,
                                          callback: function ($$v) {
                                            _vm.$set(_setup.model, "width", $$v)
                                          },
                                          expression: "model.width",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _c(_setup.ValidationProvider, {
                            attrs: {
                              slim: "",
                              rules: _setup.validation.rules,
                              "custom-messages": _setup.validation.messages,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ failed, errors }) {
                                    return [
                                      _c(_setup.CInput, {
                                        staticClass: "flex-fill",
                                        attrs: {
                                          label: "Height (px)",
                                          type: "decimal",
                                          min: 1,
                                          step: 1,
                                          error: failed,
                                          "error-msg": errors[0],
                                        },
                                        model: {
                                          value: _setup.model.height,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.model,
                                              "height",
                                              $$v
                                            )
                                          },
                                          expression: "model.height",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(_setup.CButton, {
                        staticClass: "w-100 mt-2",
                        attrs: {
                          variant: "primary",
                          text: "Set Background Color",
                          disabled: invalid,
                        },
                        on: { click: _setup.setBgColor },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }